module.exports = "/assets/logo_sg_illustrator_1_1-bacc4af28ddb0607a10bb5f6d0aead9d.png";